import {useMemo} from "react";
import {getCustomerNoteSectionVisibility} from "../../../core/models/static/routes/notebook-tags";
import useAccessLevels from "../use-access-levels";


/**
 * Customer note section visibility aligned with customer sidebar access-level gates.
 */
const useCustomerNoteSectionVisibility = () => {
    const {packages} = useAccessLevels();
    return useMemo(() => getCustomerNoteSectionVisibility(packages), [packages],);
};

export default useCustomerNoteSectionVisibility;
